<template>
  <div class="myaccount">
    <card :image="user.imageUrl" :title="`${user.name}`">
      <template v-slot:actions>
        <b-button
          variant="primary"
          :disabled="disable"
          href="https://console.tactint.com/"
          target="_blank"
        >
          <b-icon icon="arrow-right-square" aria-hidden="true" class="mr-2"></b-icon>Centralised Console
        </b-button>
        <br />
        <ul class="list-group mb-4">
          <li class="list-group-item d-flex justify-content-between">
            <strong>Email address</strong>
            <span>{{user.email}}</span>
          </li>
          <li class="list-group-item d-flex justify-content-between">
            <strong>Mobile number</strong>
            <span>{{user.mobileNumber}}</span>
          </li>
        </ul>

        <b-button variant="outline-info" :disabled="disable" @click.prevent="signOut">
          <b-icon icon="power" aria-hidden="true" class="mr-2"></b-icon>Sign out
        </b-button>
      </template>
    </card>
  </div>
</template>

<script>
import Card from "../ui/Card";

export default {
  name: "MyAccount",
  data() {
    return {
      disabled: false,
    };
  },
  components: {
    Card,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    async signOut() {
      try {
        this.disable = true;
        this.$store.commit("setUser", { user: null });
        this.$router.push({ name: "session" });
        location.href = "https://auth.tactint.com/auth/v3b4/logout";
      } catch (e) {
        this.disable = false;
        if (e.response && e.response.status === 500)
          this.$router.push({ name: "error" });
        //console.log(e.response);
      }
    },
  },
};
</script>
